import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('users');

export const apiRoutes = {
  // users dashboard
  loadUsersCount: `${URI_PREFIX}/users-count`,
  topProductiveUsers: `${URI_PREFIX}/top-productive-users`,
  userStatusChart: `${URI_PREFIX}/users-per-status`,
  permissionGroupsCount: `${URI_PREFIX}/permission-groups-count`,
  usersPerPermissionChart: `${URI_PREFIX}/users-per-permission-group`,
  totalNumberOfUsers: `${URI_PREFIX}/users-per-month`,
  logs: `logs`,
  achievements: `${URI_PREFIX}/achievements`,

  // user profile
  userData: `${URI_PREFIX}/show`,
  // loadUserActivities: `${URI_PREFIX}/users-count`,
  userProductivityChart: `${URI_PREFIX}/user-productivity`,
  averageHoursChart: `${URI_PREFIX}/average-logged-hours`,
  userCreatedActivities: `${URI_PREFIX}/created-activities`,
  loadUserActivitiesHashtags: `${URI_PREFIX}/user-activities-count/hashtags`,
  loadUserActivitiesTweets: `${URI_PREFIX}/user-activities-count/tweets`,
  loadUserActivitiesInstagramPosts: `${URI_PREFIX}/user-activities-count/posts/instagram`,
  loadUserActivitiesTiktokPosts: `${URI_PREFIX}/user-activities-count/posts/tiktok`,
  loadUserActivitiesLinkedinPosts: `${URI_PREFIX}/user-activities-count/posts/linkedin`,
  loadUserActivitiesSets: `${URI_PREFIX}/user-activities-count/sets`,
  loadUserActivitiesSources: `${URI_PREFIX}/user-activities-count/source-editions`,
  loadUserActivitiesTopics: `${URI_PREFIX}/user-activities-count/topics`,
  loadUserActivitiesEntities: `${URI_PREFIX}/user-activities-count/entities`,
  loadUserActivitiesInfluencers: `${URI_PREFIX}/user-activities-count/influencers`,
  loadUserActivitiesReports: `${URI_PREFIX}/user-activities-count/reports`,
  loadUserActivitiesVideos: `${URI_PREFIX}/user-activities-count/videos`,
  loadUserActivitiesOrganizations: `${URI_PREFIX}/user-activities-count/organizations`,
  loadUserLogs: `${URI_PREFIX}/logs`,

  //permission groups
  permissionGroupsTab: `${URI_PREFIX}/permission-groups/`,
  permissionGroupsTrashedTab: `${URI_PREFIX}/permission-groups/trashed`,
  activePermissionsAutoComplete: `${URI_PREFIX}/permission-groups/activated`,
  trashedPermissionsAutoComplete: `${URI_PREFIX}/permission-groups/trashed`,
  allPermissionGroups: `${URI_PREFIX}/modules-permissions`,
  addPermissionGroup: `${URI_PREFIX}/permission-groups/store`,
  showPermissionGroup: `${URI_PREFIX}/permission-groups/show`,
  updatePermission: `${URI_PREFIX}/permission-groups/update`,
  trashPermission: `${URI_PREFIX}/permission-groups/trash`,
  deletePermission: `${URI_PREFIX}/permission-groups/delete`,
  restorePermission: `${URI_PREFIX}/permission-groups/restore`,
  permissionAutoComplete: `${URI_PREFIX}/permission-groups/roles`,

  //user autocomplete api
  usersAutoComplete: `settings/${URI_PREFIX}/activated`,
  blockedUsersAutoComplete: `${URI_PREFIX}/blocked`,
  trashedUsersAutoComplete: `${URI_PREFIX}/trashed`,

  // users table
  activeTab: `${URI_PREFIX}/all-activated`,
  blockTab: `${URI_PREFIX}/all-blocked`,
  trashedTab: `${URI_PREFIX}/all-trashed`,
  restoreUsers: `${URI_PREFIX}/restore`,
  activeUsers: `${URI_PREFIX}/unblock`,
  blockUsers: `${URI_PREFIX}/block`,
  deleteUsers: `${URI_PREFIX}/delete`,
  trashUsers: `${URI_PREFIX}/trash`,
  addToPermission: `${URI_PREFIX}/add-permissions`,

  //add new user
  addNewUser: `${URI_PREFIX}/store`,
  updateUser: `${URI_PREFIX}/update`,
  loadUserDetails: `${URI_PREFIX}/show`,

  // user activities
  userActivities: `${URI_PREFIX}/user-activities/`,
  nameAutoComplete: `${URI_PREFIX}/auto-complete`,
  loadModules: `${URI_PREFIX}/user-activities/modules`,
  loadActivities: `${URI_PREFIX}/activities`,
};
